import React, {Component} from "react";
import "./ProcessingPayment.scss";
import {LoanData} from "../../../loan-details/model/LoanData";
import {CallForHelpLink} from "../../../../app/tileable/instructions/contats/CallForHelpLink";
import {EmailForHelpLink} from "../../../../app/tileable/instructions/contats/EmailForHelpLink";
import {LoanTypeUtil} from "../../../../util/LoanTypeUtil";

interface Props {
    loan: LoanData;
}

export class ProcessingPayment extends Component<Props> {
    render() {
        const support = this.props.loan.support;
        return (
            <div id="processing-payment-summary">
                <div className="item">
                    <h3>Your payment is being processed.</h3>
                </div>

                <div className="item processing-payment-note">
                    <p className="processing-payment-note__main">
                        Your payment is currently being processed by our services.
                        You may safely close this page.
                    </p>
                    <p className="processing-payment-note__support">
                        As always, <CallForHelpLink support={support}>call</CallForHelpLink> or <EmailForHelpLink
                        support={support}>email</EmailForHelpLink> {this.supportAgent()} if you have any questions.
                    </p>
                </div>
            </div>
        );
    }

    private supportAgent = () => LoanTypeUtil.supportAgentOf(this.props.loan);
}
